export const createActionMatcher = (logger) => {
    const actionMap = {};
    const matcher = {
        match: (actionType, biEvenFn) => {
            actionType.forEach((actionType) => {
                if (actionMap[actionType]) {
                    throw new Error(`Action matcher for ${actionType} already exists`);
                }
                else {
                    actionMap[actionType] = (action) => biEvenFn(action);
                }
            });
            return matcher;
        },
        execute: (action) => {
            const eventParamCallback = actionMap[action.type];
            const eventPromise = eventParamCallback ? eventParamCallback(action) : null;
            eventPromise?.then((eventPayload) => {
                if (eventPayload) {
                    logger.report(eventPayload);
                }
            });
        },
    };
    return matcher;
};
//# sourceMappingURL=create-action-matcher.js.map